module.exports = {
    coopAddress: process.env.VUE_APP_Coop || "0x29A6148b00a37Cfa936d7d0d62a421416065Cb8E",
    eggsNFTAddress: process.env.VUE_APP_EggG || "0x5AcB207E6b6Ca498A74b5108f76DF10427491f15",
    eggsGameAddress: process.env.VUE_APP_EggsGame || "0xc0370668E1D24e428C7E3081C0253ff46138ac2f",
    eggsTokenAddress: process.env.VUE_APP_EGG || "0x13412B927C115c80699644CCBc6a64EF6395A4C6",
    lotteryAddress: process.env.VUE_APP_Lottery || "0x7a5A227C349Fff59ca69066675DdcAcfE26802D9",
    lotteryNFTAddress: process.env.VUE_APP_LotteryNFT || "0xd24525B6F51Ff87eCDE0C3279A6AbbE32edc6f97",
    provider: "",
    providers : {
        default: "",
        moralis: {
            key: "dwzfgOXQJk8KQhXTJ2iTvlTXu6JbHtb5l1v124cIgcwkb37MMaBlINuaODCbAnY3"
        }
    },
    // ganache
    // DEFAULT_NETWORK: {id: 5777, hex: "0x539"},
    //  mumbai
    DEFAULT_NETWORK: {id: 80001, hex: "0x13881"},
    //  polygon
    // DEFAULT_NETWORK: {id: 137, hex: "0x89"},
}